import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import MainLayout from '../layouts/main';
import SimpleLayout from '../layouts/simple';
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
//
import {
  // Auth
  LoginPage,
  RegisterPage,
  VerifyCodePage,
  NewPasswordPage,
  ResetPasswordPage,
  // Dashboard: General
  GeneralAppPage,
  GeneralAnalyticsPage,
  AISettingsPage,
  // Dashboard: User
  UserListPage,
  // UserEditPage,
  UserCardsPage,
  UserCreatePage,
  UserProfilePage,
  // UserAccountPage,
   // Dashboard: Task
   TaskListPage,
   TasksViewPage,
   ReviewedTasks,
  //  TaskEditPage,
   TaskCreateNewPage,
   TaskCreatePage,
  //
  BlankPage,
  PermissionDeniedPage,
  //
  Page500,
  Page403,
  Page404,
  HomePage,
  OrgSelectPage,
  //
  TaskDetailsPage,
  ApprovedListPage,
  GPSPage,
  PrivacyPolicy,
  AnimalsINvolvedMap,
  AnalystClaims,
} from './elements';


// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Auth
    {
      path: 'auth',
      // path: '/',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          ),
        },
        { path: 'login-unprotected', element: <LoginPage /> },
        { path: 'register-unprotected', element: <RegisterPage /> },
        {
          element: <CompactLayout />,
          children: [
            { path: 'reset-password', element: <ResetPasswordPage /> },
            { path: 'new-password/:token', element: <NewPasswordPage /> },
            { path: 'verify', element: <VerifyCodePage /> },
          ],
        },
      ],
    },

    // Dashboard
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <GeneralAppPage /> },
        { path: 'analytics', element: <GeneralAnalyticsPage /> },
        { path: 'ai-settings', element: <AISettingsPage /> },
        { path: 'cvo-locator', element: <GPSPage /> },
        { path: 'animals-involved', element: <AnimalsINvolvedMap /> },
        {
          path: 'user',
          children: [
            { element: <Navigate to="/dashboard/user/profile" replace />, index: true },
            { path: 'profile', element: <UserProfilePage /> },
            { path: 'cards', element: <UserCardsPage /> },
            { path: 'list', element: <UserListPage /> },
            { path: 'new', element: <UserCreatePage /> },
            { path: ':id/edit', element: <UserCreatePage /> },
          ],
        },
        {
          path: 'task',
          children: [
            { element: <Navigate to="/dashboard/task/profile" replace />, index: true },
            { path: 'list', element: <TaskListPage /> },
            { path: 'approved', element: <ApprovedListPage /> },
            { path: 'list-view', element: <TasksViewPage /> },
            { path: 'reviewed-claims', element: <ReviewedTasks /> },
            { path: 'analyst-claims', element: <AnalystClaims /> },
            { path: 'new', element: <TaskCreateNewPage /> },
            { path: ':id/edit', element: <TaskCreatePage /> },
            { path: ':guid', element: <TaskDetailsPage /> },
          ],
        },
        
        { path: 'permission-denied', element: <PermissionDeniedPage /> },
        { path: 'blank', element: <BlankPage /> },
      ],
    },

    // Main Routes
    {
      element: <MainLayout />,
      children: [
        { element: <HomePage />, index: false },
      
        // Demo Components
      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { path: 'org-select', element: <OrgSelectPage /> },
        { path: 'privacy-policy', element: <PrivacyPolicy /> },
      ],
    },
    {
      element: <CompactLayout />,
      children: [
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
      ],
    },
    { path: '/', element: <Navigate to="/dashboard" replace /> },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
